const extractQueryParam = (urlString, paramName) => {
  const url = new URL(urlString);
  const params = new URLSearchParams(url.search)
  return params.getAll(paramName)
}

export { extractQueryParam }
